import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 55px; 
    }`
  }
`

const BasicText = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="72" height="40" viewBox="0 0 72 40" isFromWidgetChoice={isFromWidgetChoice}>
      <text 
        className="fillHoverSVG"
        transform="translate(20 36)"
        fontSize="50"
        fontFamily="Roboto-Black, Roboto"
        fill="#707070"
      >
        A
      </text>
    </SVG>
  </IconContainer>
)

export default BasicText